import { apiClient } from './client'

export type SubtitleCue = {
  text: string
  startMs: number
  endMs: number
  language: string
}

export type ExerciseVideo = {
  id: string
  key: string
  title: string
  description?: string | null
  videoUrl: string
  videoObjectKey: string
  thumbnailUrl?: string | null
  thumbnailObjectKey?: string | null
  subtitles: SubtitleCue[]
  createdAt: string
  updatedAt?: string | null
}

export type ExerciseVideoPayload = {
  key: string
  title: string
  description?: string | null
  videoUrl: string
  videoObjectKey: string
  thumbnailUrl?: string | null
  thumbnailObjectKey?: string | null
  subtitles: SubtitleCue[]
}

export type UploadUrlPayload = {
  fileName: string
  contentType?: string
  kind?: 'video' | 'thumbnail'
  videoKey?: string
  overwriteByKey?: boolean
}

export type UploadUrlResponse = {
  uploadUrl: string
  publicUrl: string
  objectKey: string
}

export type DirectUploadPayload = {
  file: File
  kind?: 'video' | 'thumbnail'
  videoKey?: string
  overwriteByKey?: boolean
}

export type DirectUploadResponse = {
  publicUrl: string
  objectKey: string
}

export async function getExerciseVideos(): Promise<ExerciseVideo[]> {
  const { data } = await apiClient.get<ExerciseVideo[]>('/api/admin/exercise-videos')
  return data
}

export async function getExerciseVideo(key: string): Promise<ExerciseVideo> {
  const { data } = await apiClient.get<ExerciseVideo>(`/api/admin/exercise-videos/${key}`)
  return data
}

export async function createExerciseVideo(payload: ExerciseVideoPayload): Promise<ExerciseVideo> {
  const { data } = await apiClient.post<ExerciseVideo>('/api/admin/exercise-videos', payload)
  return data
}

export async function updateExerciseVideo(id: string, payload: ExerciseVideoPayload): Promise<ExerciseVideo> {
  const { data } = await apiClient.put<ExerciseVideo>(`/api/admin/exercise-videos/${id}`, payload)
  return data
}

export async function deleteExerciseVideo(id: string): Promise<void> {
  await apiClient.delete(`/api/admin/exercise-videos/${id}`)
}

export async function generateExerciseVideoUploadUrl(payload: UploadUrlPayload): Promise<UploadUrlResponse> {
  const { data } = await apiClient.post<UploadUrlResponse>('/api/admin/exercise-videos/upload-url', payload)
  return data
}

export async function uploadExerciseVideoFileDirect(payload: DirectUploadPayload): Promise<DirectUploadResponse> {
  const formData = new FormData()
  formData.append('file', payload.file)
  formData.append('kind', payload.kind ?? 'video')

  if (payload.videoKey) {
    formData.append('videoKey', payload.videoKey)
  }

  if (payload.overwriteByKey !== undefined) {
    formData.append('overwriteByKey', String(payload.overwriteByKey))
  }

  const { data } = await apiClient.post<DirectUploadResponse>('/api/admin/exercise-videos/upload', formData)
  return data
}
